// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"b4682fc6","296":"11efc086","315":"8c0396a4","381":"35ddf167","474":"4090afd0","756":"b18a2a3f","989":"f8c275a6"}[chunkId] + ".chunk.css";
};